import { motion } from 'framer-motion';
import type { SpeakerType } from 'graphql/types';

import { fadeVars, fadeItemVars } from 'utils/animations';
import Speaker from '../Speaker';

import css from './SpeakersFullList.module.scss';

interface IProps {
  // eslint-disable-next-line react/require-default-props
  title?: string;
  speakers: SpeakerType[];
  cardSize?: 'medium' | 'large';
}

export default function SpeakersFullList({
  title = '',
  speakers = [],
  cardSize = 'medium',
}: IProps) {
  return (
    <motion.div initial="hidden" animate="visible" variants={fadeVars}>
      {title && <h1 className={css.title}>{title}</h1>}
      <div className={css.speakers}>
        {speakers.map((speaker) => (
          <motion.div
            key={speaker.id}
            variants={fadeItemVars}
            className={css.speakersItem}
          >
            <Speaker speaker={speaker} size={cardSize} />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
